module.exports = __webpack_public_path__ + "img/p2-p2-diaoxiang.d3b73eb8.gif";